import fingerprintJs from "@fingerprintjs/fingerprintjs";
import { reatomAsync } from "@reatom/async";

import { authAtom } from "../atoms/authAtom";

export const setVisitorAction = reatomAsync(async (ctx) => {
  const visitorId = ctx.get(authAtom.cookieAtom).visitorId;
  if (visitorId) return;
  const fpPromise = await fingerprintJs.load();
  const fpResult = await fpPromise.get();
  authAtom.set(ctx, "visitorId", fpResult.visitorId, {
    path: "/",
    maxAge: 99999999999,
  });
}, "setVisitorAction");
